import {
  EcommerceProductsAction,
  LOAD_ECOMMERCE_PRODUCT,
  LOAD_ECOMMERCE_PRODUCT_DROPDOWNS,
  LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_FAIL,
  LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_SUCCESS,
  LOAD_ECOMMERCE_PRODUCT_FAIL,
  LOAD_ECOMMERCE_PRODUCT_SUCCESS,
  LOAD_ECOMMERCE_PRODUCT_VARIATIONS,
  LOAD_ECOMMERCE_PRODUCT_VARIATIONS_FAIL,
  LOAD_ECOMMERCE_PRODUCT_VARIATIONS_SUCCESS,
  LoadEcommerceProduct,
  LoadEcommerceProductDropdowns,
  LoadEcommerceProductDropdownsFails,
  LoadEcommerceProductDropdownsSuccess,
  LoadEcommerceProductFails,
  LoadEcommerceProductSuccess,
  LoadEcommerceProductVariationsFails,
  LoadEcommerceProductVariationsSuccess
} from "../actions";
import {IEcommerceProduct, IProductsSetting} from "../../websites/website/ecommerce/ecommerce-product.interface";
import {
  IAttribute,
  ICategory,
  ITag,
  IVariation
} from "../../websites/website/ecommerce/products/add-product/add-product-form.interface";

export interface IEcommerceProductEntityState {
  product: IEcommerceProduct;
  variations: IVariation[];
  dropdowns: {
    categories: ICategory[];
    tags: ITag[];
    products: IEcommerceProduct[];
    settings: IProductsSetting;
    products_attributes: IAttribute[];
    currency_symbol: string;
  };
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceProductState {
  entities: { [websiteId: number]: IEcommerceProductEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceProductState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceProductState = initialState, action: EcommerceProductsAction): IEcommerceProductState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_PRODUCT:
      payload = (<LoadEcommerceProduct>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_PRODUCT_SUCCESS:
      payload = (<LoadEcommerceProductSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            product: payload.product,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_PRODUCT_FAIL:
      payload = (<LoadEcommerceProductFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
    case  LOAD_ECOMMERCE_PRODUCT_VARIATIONS:
      payload = (<LoadEcommerceProductVariationsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
          }
        }
      };

    case LOAD_ECOMMERCE_PRODUCT_VARIATIONS_SUCCESS:
      payload = (<LoadEcommerceProductVariationsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            variations: payload.variations,
          }
        }
      };

    case  LOAD_ECOMMERCE_PRODUCT_VARIATIONS_FAIL:
      payload = (<LoadEcommerceProductVariationsFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
          }
        }
      };

    case  LOAD_ECOMMERCE_PRODUCT_DROPDOWNS:
      payload = (<LoadEcommerceProductDropdowns>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
          }
        }
      };

    case LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_SUCCESS:
      payload = (<LoadEcommerceProductDropdownsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            dropdowns: payload.dropdowns,
          }
        }
      };

    case  LOAD_ECOMMERCE_PRODUCT_DROPDOWNS_FAIL:
      payload = (<LoadEcommerceProductDropdownsFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
          }
        }
      };
  }

  return state;
}
